import destinationsListCache from '../../../../scripts/cache/destinationsList.json';
import viatorDestinationsIds from '../../../../scripts/cache/viator_to_tripshock.json';
import viatorDestinationsDict from '../../../../scripts/cache/viator_destinations_dict.json';
import { VActivityPage } from '@/screens/VActivityPage/ui/VActivityPage';
import { GetStaticProps } from 'next';
import { getRedirectsPath } from '@/common/service/api/Redirects/getRedirectsPath';
import { getRecommends } from '@/shared/FeaturedActivities/service/ApiFeaturedActivities';
import { convertToSlug, parseSlugId } from '@/common/app/utils/viator';
import { getViatorProduct } from '@/entities/Viator/service/getViatorProduct';
import { getViatorBreadcrumbs } from '@/entities/Viator/app/getActivityBreadcrumbs';
import { VActivityPageProps } from '@/screens/VActivityPage/ui/VActivityPage.types';

export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking',
    };
}

type PageStaticProps = {
    'vDestinationSlug': string;
    'slug-id': string;
};

export const getStaticProps: GetStaticProps<VActivityPageProps, PageStaticProps> = async ({
    params,
}) => {
    try {
        if (!params) {
            throw new Error(`PAGE ACTIVITY: BAD PARAMS: ${params}`);
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const [_, productCode] = parseSlugId(params['slug-id'] as string);

        const product = await getViatorProduct(productCode);

        if (!product) {
            const redirectPath = await getRedirectsPath(`/tours/${params['vDestinationSlug']}/${params['slug-id']}`);

            if (redirectPath === '/404/') {
                return {
                    notFound: true,
                };
            }

            return {
                revalidate: Number(process.env.CACHE_ENV),
                redirect: {
                    destination: redirectPath.toLowerCase(),
                    statusCode: 301,
                },
            };
        }

        const realSlug = product.title.toLowerCase().replaceAll(' ', '-');
        const destinationSlugs = product.ui.destinationIds
            .map((id) => (viatorDestinationsDict as unknown as { [key: string]: string })[id]);
        const currentVDestination = destinationSlugs.find(s => s === params.vDestinationSlug.toLowerCase()) || destinationSlugs[0] || '';
        const vDestinationId = product.ui.destinationIds[destinationSlugs.findIndex(s => s === currentVDestination)];

        const rightUrl = `/tours/${currentVDestination}/${convertToSlug(product.title)}-${productCode.toLowerCase()}/`;

        const incomingUrl = `/tours/${params.vDestinationSlug}/${params['slug-id']}/`;

        if (incomingUrl !== rightUrl) {
            return {
                revalidate: Number(process.env.CACHE_ENV),
                redirect: {
                    destination: rightUrl,
                    statusCode: 301,
                },
            };
        };

        const vrDestinations = (viatorDestinationsIds as unknown as { [key: string]: string })

        const vrDestinationId = product.ui.destinationIds
            .find((destId) => vrDestinations[destId]);

        const tsDestinationId = vrDestinationId && vrDestinations[vrDestinationId];

        const currentDestination = tsDestinationId
            ? (destinationsListCache.find((i) => i.id === tsDestinationId) || null)
            : null;


        const breadcrumbs = getViatorBreadcrumbs(
            product.title,
            `/tours/${realSlug}-${productCode}`,
            currentDestination
        );

        const [recommends] = await Promise.all([
            currentDestination
                ? getRecommends({
                    destination_id: currentDestination.id,
                })
                : [],
        ]);

        return {
            revalidate: 900,
            props: {
                breadcrumbs,
                product,
                currentDestination,
                recommends,
                destinationId: vDestinationId,
            },
        };
    } catch (e) {
        throw new Error((e as Error).message);
    }
};

export default VActivityPage;
